import { createContext, useContext, useLayoutEffect, useRef } from "react";
import { useReducedMotion } from "motion/react";

import type { TicketId } from "./tickets";

export const DemoInViewContext = createContext(false);

export function useStagger() {
  const reduceMotion = useReducedMotion();
  const inView = useContext(DemoInViewContext);
  return (index: number) =>
    reduceMotion
      ? {}
      : {
          initial: { opacity: 0, y: 6 },
          animate: inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 6 },
          transition: { delay: 0.1 + index * 0.15, duration: 0.3 },
        };
}

export function useScrollToTop(key: string) {
  const containerRef = useRef<HTMLDivElement>(null);
  useLayoutEffect(() => {
    if (containerRef.current) containerRef.current.scrollTop = 0;
  }, [key]);

  return containerRef;
}

export function useFirstScroll(
  ticketId: TicketId,
  report: (target: HTMLElement) => void,
) {
  const reported = useRef(new Set<TicketId>());
  return (event: React.UIEvent<HTMLElement>) => {
    if (event.currentTarget.scrollTop <= 0) return;
    if (reported.current.has(ticketId)) return;
    reported.current.add(ticketId);
    report(event.currentTarget);
  };
}
